import { apiUriHttp } from '../conf/apiConf';
import { headers_custom_func_get } from '../Auth/get_set_AuthHeaders';
async function deleteDataFromApi(apiName: string, baseUri: string = apiUriHttp()): Promise<any> {
  try {
    const response = await fetch(baseUri + apiName, {
      headers: headers_custom_func_get(),
      method: 'DELETE',
      //  body: JSON.stringify(data)
    });
    if (!response.ok) {
      if (response.status === 401) {
        console.log('UNAUTHORIZED');
      }
      throw new Error('Failed to fetch equipment groups');
    } else {
      const data = await response.json();
      return data.responseData;
    }
  } catch (error) {
    console.log(error);
    // Handle the error, such as displaying an error message or setting an error state
    throw error; // Re-throw the error to propagate it to the caller
  }
}
async function deleteDataFromApiWithBody(apiName: string,DataToSend: any, baseUri: string = apiUriHttp()): Promise<any> {
  try {
    const response = await fetch(baseUri + apiName, {
      headers: headers_custom_func_get(),
      method: 'DELETE',
      body: JSON.stringify(DataToSend)
    });
    if (!response.ok) {
      if (response.status === 401) {
        console.log('UNAUTHORIZED');
      }
      throw new Error('Failed to fetch equipment groups');
    } else {
      const data = await response.json();
      return data.responseData;
    }
  } catch (error) {
    console.log(error);
    // Handle the error, such as displaying an error message or setting an error state
    throw error; // Re-throw the error to propagate it to the caller
  }
}
export { deleteDataFromApi,deleteDataFromApiWithBody };
